import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Job from './pages/Job';
import Products from './pages/Products';
import Service from './pages/Service';
import View from './pages/View';
import CreateYourProfile from './pages/CreateYourProfile';
import ApplyForJobs from './pages/ApplyForJobs';
import ScheduleInterview from './pages/ScheduleInterview';
import Header from './components/Header';
import Footer from './components/Footer';

export default function App() {
  return (
    <BrowserRouter>
      <Header />

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/job' element={<Job />} />
        <Route path='/products' element={<Products />} />
        <Route path='/service' element={<Service />} />
        <Route path='/view/:id' element={<View />} />
        <Route path='/ApplyForJobs' element={<ApplyForJobs />} />
        <Route path='/CreateYourProfile' element={<CreateYourProfile />} />
        <Route path='/ScheduleInterview' element={<ScheduleInterview />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}
